<template>
  <div class="process-indicator">
    <ul class="">
      <li v-bind:class="{ selected: this.$store.state.processIndicator.step1 }">
        <i class="step1"></i><span>약관동의 및 실명확인</span>
      </li>

      <li v-bind:class="{ selected: this.$store.state.processIndicator.step2 }">
        <i class="step2"></i><span>가입자 정보입력</span>
      </li>

      <li v-bind:class="{ selected: this.$store.state.processIndicator.step3 }">
        <!-- [ST][CSR:RITM2694040] 안면인증 1차 시범서비스 -->
        <i class="step3"></i><span>작성내용 확인 및 본인인증, 안면인증</span>
        <!-- [ED][CSR:RITM2694040] 안면인증 1차 시범서비스 -->
      </li>

      <li v-bind:class="{ selected: this.$store.state.processIndicator.step4 }">
        <i class="step4"></i><span>가입신청 완료</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ProgressIndicator'
}
</script>

<style scoped></style>
